<template>
                <QueueGrid></QueueGrid>
</template>

<script>

    import QueueGrid from "./QueueGrid";

    export default {
        components: {QueueGrid},
        data() {
            return {
                showModal: false,
            };
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },

        },
        methods: {},
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }
        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    };
</script>
<style></style>
